import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';


const otpSendApi = environment.base_url + "user/send-otp";
const registerApi = environment.base_url + "user/create";
const detailRegisterApi = environment.base_url + "user/update";
const getUserDetailApi = environment.base_url + "user/get";
const getCouponDiscountApi = environment.base_url + "master/get_coupon";
const resetPasswordApi = environment.base_url + "user/reset_password";
const forgotPasswordApi = environment.base_url + "user/send-otp";
const forgotPassVerifyOTPApi = environment.base_url + "user/verify_otp";
const setNewPasswordApi = environment.base_url + "user/forgot_password";
const profileCompletionAPI = environment.base_url + "user/profile_percentage";
const paymentReceiptAPI = environment.base_url + "payment/create";
const awsRequestAPI = environment.base_url + "getS3Url";

@Injectable({
  providedIn: 'root'
})

export class AuthService {
  private source = new BehaviorSubject<string>("");
  currentSource = this.source.asObservable();

  private details = new BehaviorSubject<string>("");
  receiveDetails = this.details.asObservable();

  private forgotData = new BehaviorSubject<string>("");
  receiveForgotData = this.forgotData.asObservable();

  changeForgotData(forgotData: any) {
    this.forgotData.next(forgotData);
  }

  couponDiscount = new BehaviorSubject<any>(0);

  getCouponDiscountAmount() {
    return this.couponDiscount.asObservable();
  }

  setCouponDiscountAmount(amount) {
    this.couponDiscount.next(amount);
  }

  // couponDetails = new Subject<any>();

  // getcouponDetails() {
  //   return this.couponDetails.asObservable();
  // }

  // setcouponDetails(data) {
  //   this.couponDetails.next(data);
  // }

  // changeData = new Subject<any>();
  otp = new Subject<any>();
  sendResponse = new Subject<any>()
  // allDetails = new Subject<any>()
  sendForgotData = new Subject()
  panelListItem = new Subject()
  showLoader = new BehaviorSubject<Boolean>(false);

  changeSource(message: string) {
    this.source.next(message);
  }

  changeDetail(message: string) {
    this.details.next(message);
  }

  createSession(param) {
    return this.http.get(param)
  }
  constructor(private http: HttpClient) { }

  sendOtp(authObj) {
    return this.http.post(`${otpSendApi}`, authObj)
  }

  registerSubmit(registerData) {
    return this.http.post(`${registerApi}`, registerData)
  }

  //After Login (Detail Register Data)
  detailRegisterSubmit(detailRegisterData, token) {
    return this.http.put(`${detailRegisterApi}`, detailRegisterData, { headers: { 'x-access-token': token } })
  }


  getUserDetail(userId, token) {
    return this.http.get(`${getUserDetailApi}/${userId}`, { headers: { 'x-access-token': token } })
  }


  //login
  login(body: any) {
    return this.http.post(environment.base_url + 'auth/login', body)
  }

  pinCodeList(pincode) {
    console.log('pincode in auth', pincode);

    return this.http.get(`https://api.postalpincode.in/pincode/${pincode}`)
  }

  stateList() {
    return this.http.get('https://cdn-api.co-vin.in/api/v2/admin/location/states');
  }

  getCouponDiscount(payload) {
    return this.http.post(`${getCouponDiscountApi}`, payload);
  }

  resetPassword(body: any) {
    return this.http.post(`${resetPasswordApi}`, body);
  }

  forgotPassword(body: any) {
    return this.http.post(`${forgotPasswordApi}`, body);
  }

  forgotPassVerifyOTP(data) {
    return this.http.post(`${forgotPassVerifyOTPApi}`, data)
  }

  setNewPassword(data) {
    return this.http.put(`${setNewPasswordApi}`, data)
  }

  profileCompletion(userId, token) {
    return this.http.get(`${profileCompletionAPI}/${userId}`, { headers: { 'x-access-token': token } })
  }

  paymentReceipt(data) {
    return this.http.post(`${paymentReceiptAPI}`, data, { headers: { 'x-access-token': sessionStorage.getItem('token') } })
  }

  awsRequest(data) {
    return this.http.post(`${awsRequestAPI}`, data, { headers: { 'x-access-token': sessionStorage.getItem('token') } })
  }

  awsResponseUrl(url, body) {
    return this.http.put(`${url}`, body);
  }
}
